import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://dw4t.be/proxy/proxy.php',  // URL du proxy PHP
  //baseURL: 'https://dw4trust-server.onrender.com/api/v1',
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': '6e552fb153cf4fd693aec72a755276ce',
  }
});

export default axiosInstance;